export const autoUpdatePeriods = {
  5: {
    key: '5',
    value: 'каждые 5 минут',
  },
  10: {
    key: '10',
    value: 'каждые 10 минут',
  },
  15: {
    key: '15',
    value: 'каждые 15 минут',
  },
};
